import { apiClient } from './client'

export interface UserPublic {
  id: string
  email?: string | null
  name?: string | null
  username?: string | null
  first_name?: string | null
  telegram_id?: number | null
  telegram_username?: string | null
  created_at?: string | null
  date_joined?: string | null
  role?: string | null
  is_active?: boolean | null
  balance?: string | null
}

export interface TokenPair {
  access_token: string
  refresh_token: string
  token_type: string
}

export interface AuthResponse extends TokenPair {
  user: UserPublic
}

export interface GuestDemoResponse extends AuthResponse {
  demo_shop_id: string
}

export interface LoginPayload {
  email: string
  password: string
}

export interface EmailRegistrationPayload {
  email: string
  password: string
  name?: string
}

export interface EmailRegistrationResponse {
  message: string
  expires_at: string
}

export interface EmailRegistrationConfirmPayload {
  code: string
}

export interface MergeStatus {
  can_add_email: boolean
  can_add_telegram: boolean
  is_fully_merged: boolean
}

export interface AddEmailPayload {
  email: string
  password?: string | null
}

export interface AddEmailResponse {
  message: string
  expires_at: string
}

export interface AddTelegramResponse {
  deep_link: string
  expires_at: string
}

export interface MergeConfirmPayload {
  code: string
}

export interface PasswordResetPayload {
  email: string
}

export interface PasswordResetResponse {
  message: string
  expires_at: string
}

export interface PasswordResetConfirmPayload {
  code: string
  password: string
}

export const authApi = {
  // Логин
  login: async (payload: LoginPayload): Promise<AuthResponse> => {
    const { data } = await apiClient.post<AuthResponse>('/api/v1/auth/login', payload)
    return data
  },

  // Получение текущего пользователя
  me: async (): Promise<UserPublic> => {
    const { data } = await apiClient.get<UserPublic>('/api/v1/auth/me')
    return data
  },

  // Логаут (отзыв refresh токенов)
  logout: async (): Promise<void> => {
    await apiClient.post('/api/v1/auth/logout')
  },

  // Логин по коду из Telegram‑бота
  loginViaTelegramCode: async (code: string): Promise<AuthResponse> => {
    const { data } = await apiClient.post<AuthResponse>('/api/v1/auth/telegram/code/login', { code })
    return data
  },

  // Гостевой вход в демо
  loginGuestDemo: async (): Promise<GuestDemoResponse> => {
    const { data } = await apiClient.post<GuestDemoResponse>('/api/v1/auth/guest-demo')
    return data
  },

  // Регистрация по email с подтверждением
  registerViaEmail: async (payload: EmailRegistrationPayload): Promise<EmailRegistrationResponse> => {
    const { data } = await apiClient.post<EmailRegistrationResponse>('/api/v1/auth/email/register', payload)
    return data
  },

  // Подтверждение регистрации по коду из email
  confirmEmailRegistration: async (code: string): Promise<AuthResponse> => {
    const { data } = await apiClient.post<AuthResponse>('/api/v1/auth/email/register/confirm', { code })
    return data
  },

  // Объединение аккаунтов
  getMergeStatus: async (): Promise<MergeStatus> => {
    const { data } = await apiClient.get<MergeStatus>('/api/v1/users/me/merge/status')
    return data
  },

  addEmail: async (payload: AddEmailPayload): Promise<AddEmailResponse> => {
    const { data } = await apiClient.post<AddEmailResponse>('/api/v1/users/me/merge/add-email', payload)
    return data
  },

  confirmEmailMerge: async (code: string): Promise<AuthResponse> => {
    const { data } = await apiClient.post<AuthResponse>('/api/v1/users/me/merge/confirm-email', { code })
    return data
  },

  addTelegram: async (): Promise<AddTelegramResponse> => {
    const { data } = await apiClient.post<AddTelegramResponse>('/api/v1/users/me/merge/add-telegram')
    return data
  },

  // Сброс пароля
  requestPasswordReset: async (payload: PasswordResetPayload): Promise<PasswordResetResponse> => {
    const { data } = await apiClient.post<PasswordResetResponse>('/api/v1/auth/password/reset', payload)
    return data
  },

  confirmPasswordReset: async (payload: PasswordResetConfirmPayload): Promise<void> => {
    await apiClient.post('/api/v1/auth/password/reset/confirm', payload)
  },
}
